import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import {
  getAnnotationToolSupervisorProjectMetricsPath,
  useAppDispatch,
  useAppSelector,
} from '@verantos-dev/core-annotation-tool';

import { DEFAULT_METRICS_VIEW, METRICS_VIEW_OPTIONS } from './constants';
import { resetAllStates, setSelectedProjectId } from './state/metricsSlice';
import { selectSelectedProjectId } from './state/selector';

const isMetricsViewId = (value: string | undefined): value is string =>
  METRICS_VIEW_OPTIONS.some((option) => option.id === value);

export interface UseProjectMetricsResult {
  projectId: string;
  selectedView: string;
  handleViewChange: (viewId: string) => void;
}

export const useProjectMetrics = (): UseProjectMetricsResult => {
  const { projectId = '', metricsView } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const storedProjectId = useAppSelector(selectSelectedProjectId);

  useEffect(() => {
    if (projectId && projectId !== storedProjectId) {
      dispatch(setSelectedProjectId(projectId));
      dispatch(resetAllStates());
    }
  }, [projectId, storedProjectId, dispatch]);

  const selectedView = isMetricsViewId(metricsView) ? metricsView : DEFAULT_METRICS_VIEW;

  const handleViewChange = (viewId: string) => {
    navigate(getAnnotationToolSupervisorProjectMetricsPath(projectId, viewId));
  };

  return { projectId, selectedView, handleViewChange };
};
